<template>
  <modal
    id="modalIntegracaoFinanceiraContabil"
    :titulo="titulo"
    :exibir="exibir"
    :campos="$refs"
    tamanho="xl"
    @fechar="fecharModal"
  >
    <form-integracao :form="dados" @refs="getRefs" />
    <template #modal-footer>
      <div class="d-flex justify-content-between w-100">
        <b-button variant="secondary" @click="fecharModal">
          {{ $t('GERAL.FECHAR') }}
        </b-button>
        <b-button variant="primary" @click="salvar">
          {{ $t('GERAL.SALVAR') }}
        </b-button>
      </div>
    </template>
  </modal>
</template>
<script>
// Utils & Aux:
import { START_LOADING, STOP_LOADING } from '@/store/Store';
import mensagem from '@/common/utils/mensagem';
import helpers from '@/common/utils/helpers';

// Services:
import IntegracaoFinanceiraContabilService from '@/common/services/integracao-financeira-contabil/integracao-financeira-contabil.service.js';

// Components:
import FormIntegracao from './Form.vue';
import Modal from '@/components/modal/Modal';

export default {
  props: {
    exibir: { type: Boolean, default: false },
    dados: { type: Object, default: Object },
  },
  components: {
    Modal,
    FormIntegracao,
  },
  data() {
    return {
      refs: [],
    };
  },
  computed: {
    titulo() {
      return !this.dados.id
        ? this.$t('GERAL.CADASTRAR')
        : this.$t('GERAL.EDITAR');
    },
  },
  methods: {
    // FUNÇÕES VALIDAÇÃO FORMULÁRIO:
    getRefs(refs) {
      this.refs = refs;
    },
    validarFormulario() {
      return helpers.validarFormulario(this.refs);
    },
    // FUNÇÕES CRUD:
    salvar() {
      if (!this.validarFormulario()) return;
      !(this.dados.id != null) ? this.criar() : this.editar();
    },
    criar() {
      this.$store.dispatch(START_LOADING);
      IntegracaoFinanceiraContabilService.criar(this.dados)
        .then(() => {
          mensagem.sucesso(this.$t('GERAL.SUCESSO'));
          this.fecharModal();
        })
        .catch((err) => {
          mensagem.showErrors(err);
        })
        .finally(() => {
          this.$store.dispatch(STOP_LOADING);
        });
    },
    editar() {
      this.$store.dispatch(START_LOADING);
      IntegracaoFinanceiraContabilService.editar(this.dados)
        .then(() => {
          mensagem.sucesso(this.$t('GERAL.SUCESSO'));
          this.fecharModal();
        })
        .catch((err) => {
          mensagem.showErrors(err);
        })
        .finally(() => {
          this.$store.dispatch(STOP_LOADING);
        });
    },
    // FUNÇÕES MODAL:
    fecharModal() {
      this.$emit('fechar', 'integracao');
    },
  },
};
</script>
